import React from "react";
import { Link } from "react-router-dom";

// Reusable page hero / breadcrumb banner
export default function PageHero({ title, subtitle, crumb }) {
  return (
    <section className="relative bg-[#0b1f3a] text-white overflow-hidden">
      <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-[#c6a15b]/10 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 h-96 w-96 rounded-full bg-[#c6a15b]/10 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <nav className="flex items-center gap-2 text-sm text-slate-300">
          <Link to="/" className="hover:text-[#c6a15b] transition">Home</Link>
          <span className="text-slate-500">/</span>
          <span className="text-[#c6a15b]">{crumb || title}</span>
        </nav>
        <h1 className="font-display font-extrabold text-4xl sm:text-5xl mt-4">{title}</h1>
        {subtitle && <p className="mt-4 text-lg text-slate-300 max-w-2xl">{subtitle}</p>}
      </div>
    </section>
  );
}
